export const libraryPage = () =>
  import("./LibraryPage").then((m) => ({ Component: m.LibraryPage }));
